import { renderWait } from './wait.js';

/** Call 1b surveys the gaps of the site before it writes the questions and answers after 11 to 15 seconds
 * (README, timings); at the expected time the bar stands at about 70. */
const EXPECTED_MS = 11000;

/** The wait between «Weiter» and the first Rückfrage, a step of its own: the reading stage has left the screen,
 * nothing here can be pressed, a bar shows that the wait is under way. */
export function renderVorbereiten(): HTMLElement {
  return renderWait({ strings: 'vorbereiten', id: 'prepare', barId: 'vbar', expectedMs: EXPECTED_MS });
}
